import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className='footer-title'><b>SNIIP </b>  ©2023</div>
            <nav className='footer-nav'>
                <ul>
                    <li>
                        <a href='https://www.linkedin.com/company/sniipcompany/about/' target="_blank" rel="noreferrer">LinkedIn</a>
                    </li>
                </ul>
            </nav>
        </footer>
    )
}

export default Footer;